import { Box, ButtonBase } from '@mui/material';
import React from 'react';
import { Icon } from '../Icon';
import theme, { TMaterialStyleItem, TMaterialStyles } from '../../theme';
import { Illustration, TIllustration } from '../Illustration';

interface IContentWrapperWithClose extends React.PropsWithChildren {
  onClose?: () => void;
  illustrationName?: TIllustration;
  wrapperContainerSx?: TMaterialStyleItem;
  isDark?: boolean;
}

export const ContentWrapperWithClose: React.FC<IContentWrapperWithClose> = ({
  children,
  onClose,
  illustrationName,
  wrapperContainerSx,
  isDark,
}) => {
  return (
    <Box
      sx={[
        materialStyles.container,
        wrapperContainerSx || null,
        isDark ? materialStyles.darkContainer : null,
      ]}
    >
      {illustrationName ? (
        <Illustration
          sx={
            isDark
              ? materialStyles.backgroundIllustrationDark
              : materialStyles.backgroundIllustration
          }
          illustrationName={illustrationName}
        />
      ) : null}
      {onClose ? (
        <ButtonBase sx={materialStyles.closeButton} onClick={onClose}>
          <Icon sx={materialStyles.closeIcon} iconName="CloseIcon" />
        </ButtonBase>
      ) : null}
      <Box zIndex={1}>{children}</Box>
    </Box>
  );
};

const materialStyles: TMaterialStyles = {
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '344px',
    width: '100%',
    bgcolor: theme.palette.primary.main,
    borderRadius: '14px',
    boxShadow: `0px 4px 0px ${theme.palette.primary.dark}`,
  },
  darkContainer: {
    bgcolor: 'black',
    boxShadow: `0px 4px 0px white`,
    border: '1px solid white',
  },
  backgroundIllustration: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
  },
  backgroundIllustrationDark: {
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
  },
  closeButton: {
    position: 'absolute',
    top: '13px',
    right: '15px',
    zIndex: 3,
  },
  closeIcon: {
    width: '14px',
    height: '14px',
  },
};
